export const valuePerDayTLCModel = [
  {
    id: "sales",
    label: "Show Sales Only",
    setVisibility: [
      { id: "avg", value: true },
      { id: "avg_trend", value: false },
    ],
  },
  {
    id: "trend",
    label: "Show Trend Only",
    setVisibility: [
      { id: "avg", value: false },
      { id: "avg_trend", value: true },
    ],
  },
  {
    id: "both",
    label: "Show Trend & Sales",
    setVisibility: [
      { id: "avg", value: true },
      { id: "avg_trend", value: true },
    ],
  },
];

export const numberOfSalesTLCModel = [
  {
    id: "count",
    label: "Show Count Only",
    setVisibility: [
      { id: "count", value: true },
      { id: "count_trend", value: false },
    ],
  },
  {
    id: "trend",
    label: "Show Trend Only",
    setVisibility: [
      { id: "count", value: false },
      { id: "count_trend", value: true },
    ],
  },
  {
    id: "both",
    label: "Show Trend & Count",
    setVisibility: [
      { id: "count", value: true },
      { id: "count_trend", value: true },
    ],
  },
];

export const totalSalesTLCModel = [
  {
    id: "count",
    label: "Show Total Only",
    setVisibility: [
      { id: "totalsales", value: true },
      { id: "totalsales_trend", value: false },
    ],
  },
  {
    id: "trend",
    label: "Show Trend Only",
    setVisibility: [
      { id: "totalsales", value: false },
      { id: "totalsales_trend", value: true },
    ],
  },
  {
    id: "both",
    label: "Show Trend & Count",
    setVisibility: [
      { id: "totalsales", value: true },
      { id: "totalsales_trend", value: true },
    ],
  },
];

export const percentageGrowthModel = [
  {
    id: null,
    setVisibility: [{ id: "percentage", value: true }],
  },
];

export const TREND_LINE_CONTROL_MODELS = {
  valuePerDay: valuePerDayTLCModel,
  numberOfSales: numberOfSalesTLCModel,
  totalSales: totalSalesTLCModel,
  percentageGrowthChart: null,
};
